import { EGiftVenue } from "./EGiftVenue.model";

export class EGiftDenomination {
	key: string;
	venueKey: number;
	value: number;
	amount: number;
	active: boolean;
	expirationDate: Date;
	prefix: string;
	displayName: string;
	isCustomAmount: boolean;
	unsaved: boolean;

	sortVal: number;

	EGiftVenue: EGiftVenue;

	public constructor(init?: Partial<EGiftDenomination>) {
		Object.assign(this, init);
	}
}
